<template>
  <MobialisFormWithValidation
    ref="contactFormInner"
    @onValidate="submit"
    novalidate
    v-av-analytics-form-submit="{ elementText: buttonText }"
  >
    <div class="row form-row pt-3">
      <div class="col-sm-6">
        <mobialis-text-input-with-validation
          :rules="{ required: true, regex: /^([^0-9]*)$/ }"
          :label="$t('message.common.firstName')"
          v-model="firstName"
          vid="firstName"
          data-cy="firstName"
        ></mobialis-text-input-with-validation>
      </div>
      <div class="col-sm-6">
        <mobialis-text-input-with-validation
          :rules="{ required: true, regex: /^([^0-9]*)$/ }"
          :label="$t('message.common.lastName')"
          v-model="lastName"
          vid="lastName"
          data-cy="lastName"
        ></mobialis-text-input-with-validation>
      </div>
    </div>
    <div class="row form-row">
      <div class="col-sm-4">
        <mobialis-text-input-with-validation
          class="input-width-180"
          rules="required|length:10"
          :label="$t('message.common.phoneNumber')"
          v-model="phoneNumber"
          vid="phoneNumber"
          placeholder="(   )"
          mask-type="phoneNumber"
          type="tel"
          data-cy="phoneNumber"
        ></mobialis-text-input-with-validation>
      </div>
      <div class="col-sm-8">
        <mobialis-text-input-with-validation
          rules="required|email"
          :label="$t('message.common.emailAddress')"
          v-model="emailAddress"
          vid="emailAddress"
          data-cy="emailAddress"
          type="email"
        ></mobialis-text-input-with-validation>
      </div>
    </div>
    <mobialis-text-input-with-validation
      class="input-width-100"
      rules="required|length:6"
      :label="$t('message.common.postalCode')"
      v-model="postalCode"
      vid="postalCode"
      mask-type="postalCode"
      data-cy="postalCode"
    ></mobialis-text-input-with-validation>
    <mobialis-check-box-with-validation
      class="mt-4 pt-2 mb-5"
      rules="required:true"
      :label="
        $t('message.eCommerceV2.offer.offerSummaryForm.tandc', {
          termsLink: $t('message.eCommerceV2.offer.offerSummaryForm.termsLink'),
          dealerName: businessName,
        })
      "
      vid="tandc"
      id="tandc"
      data-cy="tAndC"
      v-model="tandc"
    >
    </mobialis-check-box-with-validation>
    <input type="submit" hidden />
  </MobialisFormWithValidation>
</template>

<script>
import cloneDeep from 'lodash/fp/cloneDeep';
import { mapGetters } from 'vuex';

export default {
  name: 'ContactForm',
  props: {
    buttonText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      firstName: cloneDeep(this.$store.state.user.firstName),
      lastName: cloneDeep(this.$store.state.user.lastName),
      phoneNumber: cloneDeep(this.$store.state.user.phoneNumber),
      emailAddress: cloneDeep(this.$store.state.user.emailAddress),
      postalCode: cloneDeep(this.$store.state.user.postalCode),
      tandc: false,
    };
  },
  computed: {
    ...mapGetters({
      businessName: 'business/getBusinessName',
    }),
  },
  methods: {
    submitContactForm() {
      this.$refs.contactFormInner.submit();
    },
    submit(isValid) {
      if (!isValid) {
        return;
      }
      this.$store.commit('SET_LOADING', true);
      this.$store.commit('user/SET_FIRST_NAME', this.firstName);
      this.$store.commit('user/SET_LAST_NAME', this.lastName);
      this.$store.commit('user/SET_PHONE_NUMBER', this.phoneNumber);
      this.$store.commit('user/SET_EMAIL_ADDRESS', this.emailAddress);
      this.$store.commit('user/SET_POSTAL_CODE', this.postalCode);
      this.$emit('contactFormSuccessfullySubmitted');
    },
  },
};
</script>

<style lang="scss" scoped></style>
